import { PromiseSet } from "./PromiseSet";

/**
 * single _es6_ Promise avoiding gc pressure for the common pattern of isPrimed()
 *
 * PromiseSet is less relevent after removal of cubiq-services worker
 * however, it continued to be useful in avoiding a wider issue with
 * reusing long-lived promises in zone.js
 *
 *
 */
export class PrimaryPromiseSet<T> extends PromiseSet<T> {
  private readonly isPrimedPromise;
  constructor() {
    super();

    const Promise = globalThis["__zone_symbol__Promise"];

    this.isPrimedPromise = new Promise((resolve, reject) => {
      this._promiseSet.add(new PromiseSet.ResolveRejectEntry(resolve, reject));
    });

    this.isPrimedPromise.then = Promise.prototype["__zone_symbol__then"];
  }

  public get<T>(): Promise<T> {
    return this.isPrimedPromise;
  }
}
